/*
    storage方法
*/

class Storage{
    constructor(){

    }
    clearStorage(){
        let cookieStr = document.cookie;
        if(cookieStr) {
            let cookieArr = cookieStr.split("; ");
            for(let list of cookieArr){
                if(list){
                    let oCookie = list.split("=");
                    document.cookie = oCookie[0] + "=0;expires=" + new Date(0).toUTCString();
                }else{

                }
            }
        }
        localStorage.clear();
    }
    setStorage(key, value, type, expire){
        if(type == "cookie"){
            document.cookie = `${key} = ${value}`;
        }else{
            localStorage.setItem(key, value);
        }
    }
    getStorage(key, type){
        if(type == "cookie"){
            let cookieStr = document.cookie;
            if(cookieStr) {
                let cookieArr = cookieStr.split("; ");
                for(let list of cookieArr){
                    if(list){
                        let oCookie = list.split("=");
                        if(oCookie[0] == key){
                            return oCookie[1];
                        }
                    }
                }
            }
        }else{
            return localStorage.getItem(key);
        }
    }
    deleteStorage(key, type){
        if(type == "cookie"){
            let cookieStr = document.cookie;
            if(cookieStr) {
                let cookieArr = cookieStr.split("; ");
                for(let list of cookieArr){
                    if(list){
                        let oCookie = list.split("=");
                        if(oCookie[0] == key){
                            document.cookie = oCookie[0] + "=0;expires=" + new Date(0).toUTCString();
                            break;
                        }
                    }
                }
            }
        }else{
            return localStorage.deleteItem(key);
        }
    }
}
let storage = new Storage()
export default storage



// WEBPACK FOOTER //
// ./src/utils/storage/storage.js